var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBurgerDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.324.528H.62v5h29.705v-5zM43 19.517H.619v5H43v-5zm-7.157 18.988H.619v5h35.224v-5z",
    fill: "#005581"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerDark);
export default __webpack_public_path__ + "static/media/menu-burger-dark.ce7a418c46c346aad165020dabe059f4.svg";
export { ForwardRef as ReactComponent };